const PRIVATE_KEY_EXPORT_SIDECHAIN_FILE = "weave-sidechain.pvk";
const PRIVATE_KEY_EXPORT_NODE_FILE = "weave-node.pvk";
const PRIVATE_KEY_EXPORT_ACC_FILE = "weave-acc.pvk";

const Defaults = {
	PRIVATE_KEY_EXPORT_SIDECHAIN_FILE,
	PRIVATE_KEY_EXPORT_NODE_FILE,
	PRIVATE_KEY_EXPORT_ACC_FILE,
};

export default Defaults;
